import { CircularProgress } from "@material-ui/core";
import { lazy, Suspense } from "react";

// Lazy load our custom Plot component
const Plot = lazy(() => import('./CustomPlot'));

export interface PlotRendererProps {
    loading: boolean;
    plotData: any;
    plotLayout: any;
    config?: any;
    error?: boolean;
}

function PlotRenderer({loading, plotData, plotLayout, config, error}: PlotRendererProps) {
    const LoadingSpinner = () => (
        <div style={{height: '450px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <CircularProgress />
        </div>
    );

    if (error) {
        return <p style={{color: "red"}}>Hálózati hiba</p>;
    }

    if (loading) {
        return <LoadingSpinner />;
    }

    return (
        <Suspense fallback={<LoadingSpinner />}>
            <Plot
                data={plotData}
                layout={plotLayout}
                config={config || undefined}
            />
        </Suspense>
    );
}

export default PlotRenderer;